export let MenuCheckboxItemDataAttributes = /*#__PURE__*/function (MenuCheckboxItemDataAttributes) {
  /**
   * Present when the menu checkbox item is checked.
   */
  MenuCheckboxItemDataAttributes["checked"] = "data-checked";
  /**
   * Present when the menu checkbox item is not checked.
   */
  MenuCheckboxItemDataAttributes["unchecked"] = "data-unchecked";
  /**
   * Present when the menu checkbox item is disabled.
   */
  MenuCheckboxItemDataAttributes["disabled"] = "data-disabled";
  /**
   * Present when the menu checkbox item is highlighted.
   */
  MenuCheckboxItemDataAttributes["highlighted"] = "data-highlighted";
  return MenuCheckboxItemDataAttributes;
}({});